import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { isAddress } from 'utils'

export const REFERRAL_PARAM = 'addy'
const REFERRAL_EXPIRATION_MS = 5 * 60 * 1000

export default function ReferralHandler() {
  const location = useLocation()

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search)
    const referral = urlParams.get(REFERRAL_PARAM)
    const storedReferral = localStorage.getItem(REFERRAL_PARAM)
    const storedTimestamp = localStorage.getItem(`${REFERRAL_PARAM}_timestamp`)

    if (storedReferral && storedTimestamp) {
      const elapsedTime = Date.now() - parseInt(storedTimestamp, 10)
      if (elapsedTime > REFERRAL_EXPIRATION_MS) {
        localStorage.removeItem(REFERRAL_PARAM)
        localStorage.removeItem(`${REFERRAL_PARAM}_timestamp`)
      }
    }

    if (referral && isAddress(referral)) {
      localStorage.setItem(REFERRAL_PARAM, referral)
      localStorage.setItem(`${REFERRAL_PARAM}_timestamp`, Date.now().toString())
    }
  }, [location.search])

  return null
}
